import Box, {Item} from 'devextreme-react/box';
import Toolbar, {Item as ToolbarItem} from 'devextreme-react/toolbar';
import {
    CFIInformationPanel,
    MaterialOrderExitButton,
    MaterialOrderFilesButton,
    MaterialOrderInformationPanel,
    MaterialOrderNotes,
    MaterialOrderPage,
    MaterialOrderProducts,
    MaterialOrderReportType,
    PrintButton,
    PrintInvoiceButton,
    RequestMaterialCancellationButton,
    ShowMaterialDatesButton
} from '../../../features/cfi/material-order';
import '../../../css/order.scss';
import {useTitle} from '../../../contexts/title';
import {useEffect} from 'react';

export default function StandaloneMaterialOrderPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Material Order')
	}, [pageTitle])

	return (

		<div className={'content-block order-page'}>

			<MaterialOrderPage>

				<Toolbar className='button-toolbar'>
					<ToolbarItem location={'before'}>
						<PrintInvoiceButton />
					</ToolbarItem>
					<ToolbarItem location={'before'}>
						<PrintButton
							buttonCaption='Print Material Order'
							reportType={MaterialOrderReportType.MaterialOrder} />
					</ToolbarItem>
					<ToolbarItem location={'before'}>
						<ShowMaterialDatesButton />
					</ToolbarItem>
					<ToolbarItem location={'before'}>
						<MaterialOrderFilesButton />
					</ToolbarItem>
					<ToolbarItem location={'before'}>
						<RequestMaterialCancellationButton />
					</ToolbarItem>
					<ToolbarItem location={'before'}>
						<MaterialOrderExitButton />
					</ToolbarItem>
				</Toolbar>

				<Box>
					<Item ratio={1}>
						<CFIInformationPanel />
					</Item>
					<Item ratio={1}>
						<MaterialOrderInformationPanel />
					</Item>
				</Box>

				<MaterialOrderProducts />

				<MaterialOrderNotes />

			</MaterialOrderPage>
		</div>

	)
}
